module.exports = __webpack_public_path__ + "img/Trukkin_logo.f266dd05.png";